/* Premiere ticketing — shared behaviour.
   Loaded by every premiere product via the Custom Liquid block.
   Reads prices and availability from the product's own variants, so this
   file is identical for every premiere. */

document.addEventListener("DOMContentLoaded", function () {
  const reserveForm = document.getElementById('ticket-reserve-form');
  const ticketTypeSelect = document.getElementById('ticket-type');
  const quantityInput = document.getElementById('ticket-quantity');
  const minusBtn = document.getElementById('qty-minus');
  const plusBtn = document.getElementById('qty-plus');
  const ticketCountSpan = document.querySelector('.ticket-count');
  const totalPriceSpan = document.querySelector('.total-price');
  const savingsText = document.querySelector('.savings-text');
  const finalPriceSpan = document.querySelector('.final-price');
  const cartInputs = document.getElementById('reserve-cart-inputs');
  const productDataElement = document.getElementById('reserve-product-data');
  const reserveBtn = reserveForm.querySelector('.reserve-btn');
  const reserveLabel = reserveForm.querySelector('.reserve-btn__label');
  const reserveSoldOut = reserveForm.querySelector('.reserve-btn__soldout');

  // Manual sold-out override, set PER PRODUCT in the block:
  //
  //   <div id="reserve-product-data" data-sold-out="guild" ...>
  //
  // An escape hatch for taking a tier off sale WITHOUT changing Shopify
  // inventory (a venue cap, a hold, a mistake to undo). Leave the attribute
  // empty and availability comes from the variants themselves, which is the
  // normal case — setting a variant's inventory to 0 in the admin is enough.
  //
  // This deliberately reads from the block rather than being a constant here,
  // because this file is shared by every premiere: a constant would force the
  // same tier off sale on all of them.
  const SOLD_OUT_OVERRIDE = ((productDataElement && productDataElement.getAttribute('data-sold-out')) || '')
    .split(',')
    .map(function (s) { return s.trim().toLowerCase(); })
    .filter(Boolean);

  // Order matters: applyTierData() falls back to the first tier in this list
  // that is still on sale, so General Admission is deliberately last.
  const TIERS = ['diamond', 'group', 'guild', 'general'];

  // Shopify reports a variant as unavailable once inventory runs out, but only
  // when the variant actually tracks inventory. The fallbacks below cover the
  // shapes `product.variants | json` can take, and an untracked variant is
  // treated as available — which is how Shopify itself behaves.
  function isVariantAvailable(variant) {
    if (!variant) return false;
    if (typeof variant.available === 'boolean') return variant.available;
    if (variant.inventory_management && typeof variant.inventory_quantity === 'number') {
      return variant.inventory_quantity > 0 || variant.inventory_policy === 'continue';
    }
    return true;
  }

  function isSoldOut(type) {
    if (SOLD_OUT_OVERRIDE.indexOf(type) !== -1) return true;
    return !isVariantAvailable(variants[type]);
  }

  // Whether this block actually renders the tier. Not every block carries every
  // card — the General Admission card was removed from the current block, while
  // the product may well still have a `general` variant. The dropdown option is
  // the marker: no option means the customer has no way to see or choose the
  // tier, so nothing here may select it on their behalf.
  function isTierPresent(type) {
    return !!ticketTypeSelect.querySelector('option[value="' + type + '"]');
  }

  // Unit price in dollars, read from the variant. Shopify serialises prices in
  // the currency's subunit (cents), already converted to the customer's
  // presentment currency — so 15000 means $150.00 and multi-currency is free.
  //
  // Returns null when there is no variant to read, and every caller falls back
  // to the number already printed in the HTML. That keeps a missing variant
  // looking like the old hardcoded page instead of showing $0.00.
  function getUnitPrice(type) {
    const variant = variants[type];
    if (!variant || typeof variant.price !== 'number') return null;
    return variant.price / 100;
  }

  // The price printed in the block's HTML, used when the variant lookup fails.
  function getFallbackPrice(type) {
    const el = document.querySelector('[data-tier-price="' + type + '"]');
    const parsed = el ? parseFloat(el.textContent.replace(/[^0-9.]/g, '')) : NaN;
    return isNaN(parsed) ? 0 : parsed;
  }

  function priceFor(type) {
    const fromVariant = getUnitPrice(type);
    return fromVariant === null ? getFallbackPrice(type) : fromVariant;
  }

  let currentType = 'diamond';
  let currentQuantity = 1;
  let variants = { guild: null, diamond: null, group: null, general: null };

  // Per-type purchase caps.
  function getMaxQuantity(type) {
    return type === 'guild' ? 6 : 6;
  }

  // Per-type minimums. Every tier allows a single unit, including Angel Guild:
  // a Guild member may redeem their one complimentary ticket on its own without
  // being forced to add a second, paid ticket. calculatePricing() already prices
  // a quantity of 1 at $0 for guild, so nothing else has to change alongside this.
  function getMinQuantity(type) {
    return 1;
  }

  // Sync the input's min/max attributes and clamp currentQuantity if it falls
  // outside the bounds for the current type.
  function syncQuantityBounds() {
    const min = getMinQuantity(currentType);
    const max = getMaxQuantity(currentType);
    quantityInput.min = min;
    quantityInput.max = max;
    if (currentQuantity < min) currentQuantity = min;
    if (currentQuantity > max) currentQuantity = max;
    quantityInput.value = currentQuantity;
  }

  // Initialize product data and find variants
  try {
    const variantsJson = productDataElement.getAttribute('data-variants') || '[]';
    const variantsList = JSON.parse(variantsJson);

    function findByKeyword(keyword) {
      keyword = keyword.toLowerCase();
      return variantsList.find(v =>
        (v.option1 && String(v.option1).toLowerCase() === keyword) ||
        (v.option2 && String(v.option2).toLowerCase() === keyword) ||
        (v.option3 && String(v.option3).toLowerCase() === keyword) ||
        (v.title && String(v.title).toLowerCase().includes(keyword))
      );
    }

    variants.guild   = findByKeyword('guild')   || null;
    variants.diamond = findByKeyword('diamond') || null;
    variants.group   = findByKeyword('group')   || null;
    // General Admission. findByKeyword matches variant titles by SUBSTRING, so
    // a new keyword is only safe if it can't appear inside another tier's title
    // and vice versa. "general" shares no substring with guild/diamond/group,
    // so the four lookups stay independent.
    variants.general = findByKeyword('general') || null;

    console.log('Found variants:', variants);

  } catch (error) {
    console.error('Error parsing product data:', error);
  }

  // Pricing. Every number comes from priceFor(), which reads the variant, so
  // there is exactly one price per tier and it is the one Shopify will charge.
  // For the Two Pack the variant price is the price of the whole pack, so
  // quantity counts packs rather than tickets.
  function calculatePricing() {
    const unitPrice = priceFor(currentType);
    let totalPrice = 0;
    let savings = 0;

    if (currentType === 'guild') {
      // Guild members: the first ticket is the complimentary one, and every
      // ticket after it is full price. A quantity of 1 is therefore a $0 order —
      // the comp ticket redeemed on its own, with nothing bought alongside it.
      if (currentQuantity <= 1) {
        totalPrice = 0;
        savings = currentQuantity * unitPrice;
      } else {
        totalPrice = (currentQuantity - 1) * unitPrice;
        savings = unitPrice;
      }
    } else {
      totalPrice = currentQuantity * unitPrice;
      savings = 0;
    }

    return { totalPrice, savings };
  }

  // Paint the per-tier prices and sold-out treatment onto the cards. Runs once
  // on load, after the variants have been read.
  function applyTierData() {
    TIERS.forEach(function (type) {
      const soldOut = isSoldOut(type);
      const fromVariant = getUnitPrice(type);

      // Only overwrite the printed price when a real variant price was found —
      // otherwise the block's own number stays as the fallback.
      if (fromVariant !== null) {
        document.querySelectorAll('[data-tier-price="' + type + '"]').forEach(function (el) {
          el.textContent = Number.isInteger(fromVariant)
            ? String(fromVariant)
            : fromVariant.toFixed(2);
        });
      }

      const card = document.querySelector('[data-tier-card="' + type + '"]');
      if (card) {
        const ribbon = card.querySelector('[data-sold-out-ribbon]');
        if (ribbon) ribbon.hidden = !soldOut;

        // The card's own CTA: disabled and relabelled when the tier is gone.
        const cta = card.querySelector('.cta-button[data-ticket-type]');
        if (cta) {
          cta.classList.toggle('is-sold-out', soldOut);
          cta.disabled = soldOut;
          cta.setAttribute('aria-disabled', soldOut ? 'true' : 'false');
          if (soldOut) {
            if (!cta.dataset.labelOriginal) cta.dataset.labelOriginal = cta.textContent;
            cta.textContent = 'Sold Out';
          } else if (cta.dataset.labelOriginal) {
            cta.textContent = cta.dataset.labelOriginal;
          }
        }

        // Clicking the pricing panel also adds to cart, so neutralise it too.
        const panel = card.querySelector('.clickable-pricing');
        if (panel) {
          panel.style.pointerEvents = soldOut ? 'none' : '';
          panel.style.opacity = soldOut ? '0.55' : '';
        }
      }

      // Mark the dropdown option so the reason is visible before selecting it.
      const option = ticketTypeSelect.querySelector('option[value="' + type + '"]');
      if (option) {
        if (!option.dataset.labelOriginal) option.dataset.labelOriginal = option.textContent;
        option.textContent = option.dataset.labelOriginal + (soldOut ? ' — Sold Out' : '');
      }
    });

    // Never open on a sold-out tier: land on the first one still for sale that
    // this block actually shows. Without the isTierPresent() guard a block with
    // no GA card could fall through to `general` once the three premium tiers
    // sold out, leaving the dropdown blank and the reserve bar quoting a ticket
    // the customer can't see. If nothing is left, stay put and show Sold Out.
    if (isSoldOut(currentType)) {
      const firstAvailable = TIERS.find(function (type) {
        return isTierPresent(type) && !isSoldOut(type);
      });
      if (firstAvailable) {
        currentType = firstAvailable;
        ticketTypeSelect.value = firstAvailable;
      }
    }
  }

  // Swap the reserve bar between its normal and sold-out states. Called from
  // updateDisplay(), so every path that changes currentType flows through here.
  function updateSoldOutState() {
    const soldOut = isSoldOut(currentType);

    if (reserveLabel) reserveLabel.hidden = soldOut;
    if (reserveSoldOut) reserveSoldOut.hidden = !soldOut;

    if (reserveBtn) {
      reserveBtn.classList.toggle('is-sold-out', soldOut);
      reserveBtn.disabled = soldOut;
      reserveBtn.setAttribute('aria-disabled', soldOut ? 'true' : 'false');
    }

    // No quantity to pick when the type can't be bought.
    minusBtn.disabled = soldOut;
    plusBtn.disabled = soldOut;
    quantityInput.disabled = soldOut;
  }

  // Update the display
  function updateDisplay() {
    const { totalPrice, savings } = calculatePricing();

    // The Two Pack (group) is sold as a bundle, so the button counts packs
    // rather than tickets: "Reserve 2 Two Packs - $500.00".
    if (currentType === 'group') {
      const packText = currentQuantity === 1 ? 'Two Pack' : 'Two Packs';
      ticketCountSpan.textContent = `${currentQuantity} ${packText}`;
    } else {
      const ticketText = currentQuantity === 1 ? 'Ticket' : 'Tickets';
      ticketCountSpan.textContent = `${currentQuantity} ${ticketText}`;
    }

    totalPriceSpan.textContent = `$${totalPrice.toFixed(2)}`;
    finalPriceSpan.textContent = totalPrice.toFixed(2);

    if (savings > 0) {
      savingsText.style.display = 'block';
      savingsText.textContent = `Save $${savings}`;
    } else {
      savingsText.style.display = 'none';
    }

    updateSoldOutState();
    updateCartInputs();
  }

  // Update cart inputs for Shopify
  function updateCartInputs() {
    cartInputs.innerHTML = '';

    // A sold-out type contributes no variant/quantity inputs, so even a forced
    // submit posts nothing addable to /cart/add.
    if (isSoldOut(currentType)) return;

    if (currentQuantity > 0) {
      let selectedVariant = null;
      if (currentType === 'guild') selectedVariant = variants.guild;
      if (currentType === 'diamond') selectedVariant = variants.diamond;
      if (currentType === 'group') selectedVariant = variants.group;
      if (currentType === 'general') selectedVariant = variants.general;

      if (selectedVariant) {
        const idInput = document.createElement('input');
        idInput.type = 'hidden';
        idInput.name = 'id';
        idInput.value = selectedVariant.id;
        cartInputs.appendChild(idInput);

        const qtyInput = document.createElement('input');
        qtyInput.type = 'hidden';
        qtyInput.name = 'quantity';
        qtyInput.value = currentQuantity;
        cartInputs.appendChild(qtyInput);

        console.log('Cart inputs updated:', {
          variantId: selectedVariant.id,
          quantity: currentQuantity,
          type: currentType
        });
      } else {
        // Not fatal — log to console and keep form functional (user can still submit)
        console.error(`No variant found for type: ${currentType}`);
      }
    }
  }

  // Handle ticket card button clicks
  function handleTicketSelection(type, quantity) {
    currentType = type;
    // Clamp up to the type's minimum. Every tier currently allows 1, but the
    // clamp stays so a future per-tier minimum is honoured here too.
    currentQuantity = Math.max(quantity, getMinQuantity(type));

    ticketTypeSelect.value = type;
    quantityInput.value = currentQuantity;

    syncQuantityBounds();
    updateDisplay();
  }

  // Locate the theme's header cart icon. Themes name this element differently,
  // so try the common selectors in order of specificity and fall back to a
  // synthetic point in the top-right corner if the theme uses something else.
  const CART_ICON_SELECTORS = [
    '#cart-icon-bubble',
    '[data-cart-icon]',
    '.header__icon--cart',
    '.site-header__cart',
    '.header-cart',
    '.cart-link',
    'a[href$="/cart"]',
    'a[href*="/cart"]'
  ];

  function getCartTarget() {
    for (const selector of CART_ICON_SELECTORS) {
      const el = document.querySelector(selector);
      // Skip matches that are hidden or collapsed (mobile/desktop duplicate markup).
      if (el) {
        const rect = el.getBoundingClientRect();
        if (rect.width > 0 && rect.height > 0) return { el: el, rect: rect };
      }
    }

    // No recognizable cart icon — aim at the top-right of the viewport so the
    // ticket still travels in the direction of the cart.
    return {
      el: null,
      rect: { left: window.innerWidth - 80, top: 20, width: 40, height: 40 }
    };
  }

  // Animation function for flying ticket.
  // options.targetRect  — where to fly to (defaults to the reserve bar)
  // options.targetEl    — element to flash on arrival
  // options.pop         — use the scale "pop" flash instead of the reserve-bar pulse
  // options.onComplete  — called once the ticket lands
  function animateTicketToCart(sourceElement, label, options) {
    options = options || {};

    const flyingTicket = document.createElement('div');
    flyingTicket.className = 'flying-ticket';
    flyingTicket.textContent = label || 'Ticket';

    const sourceRect = sourceElement.getBoundingClientRect();
    const reserveBar = document.querySelector('.event-reserve-cta');
    const targetElement = options.targetEl !== undefined ? options.targetEl : reserveBar;
    const targetRect = options.targetRect || (reserveBar && reserveBar.getBoundingClientRect());

    flyingTicket.style.left = (sourceRect.left + sourceRect.width / 2 - 50) + 'px';
    flyingTicket.style.top = (sourceRect.top + sourceRect.height / 2 - 20) + 'px';

    document.body.appendChild(flyingTicket);

    setTimeout(() => {
      if (targetRect) {
        flyingTicket.style.left = (targetRect.left + targetRect.width / 2 - 50) + 'px';
        flyingTicket.style.top = (targetRect.top + 10) + 'px';
      }
      flyingTicket.classList.add('animate');
    }, 50);

    setTimeout(() => {
      const flashClass = options.pop ? 'cart-icon-pop' : 'reserve-highlight';
      if (targetElement) targetElement.classList.add(flashClass);
      if (document.body.contains(flyingTicket)) document.body.removeChild(flyingTicket);

      setTimeout(() => {
        if (targetElement) targetElement.classList.remove(flashClass);
      }, 600);

      if (typeof options.onComplete === 'function') options.onComplete();
    }, 850);
  }

  // Window-level handlers used by HTML onclicks. applyTierData() already sets
  // pointer-events: none on a sold-out panel, so these rarely fire in that
  // state — but the guard keeps them correct if the inline onclick is triggered
  // some other way (keyboard, another script, a theme that strips styles).
  window.handleDIAMONDPricingClick = function() {
    if (isSoldOut('diamond')) return;
    const diamondPricing = document.querySelector('.diamond-pricing') || document.querySelector('.diamond-card');
    animateTicketToCart(diamondPricing || document.body, 'Angel Single Ticket');
    handleTicketSelection('diamond', 1);
  };

  window.handleGroupPricingClick = function() {
    if (isSoldOut('group')) return;
    const groupPricing = document.querySelector('.group-pricing') || document.querySelector('.group-card');
    animateTicketToCart(groupPricing || document.body, 'Angel Two Pack');
    handleTicketSelection('group', 1);
  };

  window.handleGeneralPricingClick = function() {
    if (isSoldOut('general')) return;
    const generalPricing = document.querySelector('.ga-pricing') || document.querySelector('.ga-card');
    animateTicketToCart(generalPricing || document.body, 'General Admission');
    handleTicketSelection('general', 1);
  };

  // Add click handlers to CTA buttons
  document.addEventListener('click', function(e) {
    if (e.target.matches('.cta-button')) {
      e.preventDefault();

      // Prefer explicit data-ticket-type over button text
      // (lets us rebrand visible button copy without breaking variant routing)
      const dataType = e.target.getAttribute('data-ticket-type');

      // Sold-out cards select nothing and run no animation. The button also
      // carries `disabled`, so this is a belt-and-braces guard for the case
      // where the attribute is removed but the type is still sold out.
      if (isSoldOut(dataType)) return;

      if (dataType === 'guild') {
        animateTicketToCart(e.target, 'Angel Guild');
        handleTicketSelection('guild', 1);
        return;
      } else if (dataType === 'diamond') {
        animateTicketToCart(e.target, 'Angel Single Ticket');
        handleTicketSelection('diamond', 1);
        return;
      } else if (dataType === 'group') {
        animateTicketToCart(e.target, 'Angel Two Pack');
        handleTicketSelection('group', 1);
        return;
      } else if (dataType === 'general') {
        animateTicketToCart(e.target, 'General Admission');
        handleTicketSelection('general', 1);
        return;
      }

      const buttonText = e.target.textContent.toLowerCase();

      if (buttonText.includes('select single ticket') || buttonText.includes('select black diamond')) {
        animateTicketToCart(e.target, 'Angel Single Ticket');
        handleTicketSelection('diamond', 1);
      } else if (buttonText.includes('angel guild')) {
        animateTicketToCart(e.target, 'Angel Guild');
        handleTicketSelection('guild', 1);
      } else if (buttonText.includes('select Two Pack') || buttonText.includes('select two pack') || buttonText.includes('select group') || buttonText.includes('two tickets')) {
        animateTicketToCart(e.target, 'Angel Two Pack');
        handleTicketSelection('group', 1);
      }
    }
  });

  // Quantity controls
  minusBtn.addEventListener('click', function(e) {
    e.preventDefault();
    if (isSoldOut(currentType)) return;
    if (currentQuantity > getMinQuantity(currentType)) {
      currentQuantity--;
      quantityInput.value = currentQuantity;
      updateDisplay();
    }
  });

  plusBtn.addEventListener('click', function(e) {
    e.preventDefault();
    if (isSoldOut(currentType)) return;
    if (currentQuantity < getMaxQuantity(currentType)) {
      currentQuantity++;
      quantityInput.value = currentQuantity;
      updateDisplay();
    }
  });

  quantityInput.addEventListener('input', function() {
    if (isSoldOut(currentType)) return;
    const min = getMinQuantity(currentType);
    const max = getMaxQuantity(currentType);
    const newQuantity = parseInt(this.value) || min;
    if (newQuantity >= min && newQuantity <= max) {
      currentQuantity = newQuantity;
      updateDisplay();
    }
  });

  ticketTypeSelect.addEventListener('change', function() {
    currentType = this.value;
    syncQuantityBounds();
    updateDisplay();
  });

  // Friendly labels for the flying ticket on reserve.
  const TYPE_LABELS = {
    guild: 'Angel Guild',
    diamond: 'Angel Diamond',
    group: 'Angel Diamond 2-Pack',
    general: 'General Admission'
  };

  // ---- Add-to-cart confirmation --------------------------------------------
  // The reserve form is submitted to /cart/add. Many Shopify themes attach
  // their own submit handler to intercept that and add via AJAX. If the theme's
  // handler runs first and stops propagation, a listener on 'submit' never
  // fires — which is why hooking submit produced no visible feedback. A
  // capture-phase listener on `document` runs before any handler bound further
  // down the tree, so it cannot be pre-empted that way.

  const cartToast = document.getElementById('cart-toast');
  const cartToastDetail = document.getElementById('cart-toast-detail');
  const cartToastClose = document.getElementById('cart-toast-close');
  let toastTimer = null;

  function hideToast() {
    if (!cartToast) return;
    cartToast.classList.remove('is-visible');
  }

  function showToast(detailText) {
    if (!cartToast) return;
    if (cartToastDetail) cartToastDetail.textContent = detailText || '';
    cartToast.classList.add('is-visible');

    // Restart the dismiss timer on every add so rapid clicks don't cut the
    // last message short.
    if (toastTimer) clearTimeout(toastTimer);
    toastTimer = setTimeout(hideToast, 6000);
  }

  if (cartToastClose) {
    cartToastClose.addEventListener('click', function() {
      if (toastTimer) clearTimeout(toastTimer);
      hideToast();
    });
  }

  // Shopify exposes the live cart at /cart.js. Reading it lets the toast report
  // the real server-side item count instead of only an optimistic guess.
  function fetchCartCount() {
    if (typeof fetch !== 'function') return Promise.resolve(null);
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function(res) { return res.ok ? res.json() : null; })
      .then(function(data) {
        return (data && typeof data.item_count === 'number') ? data.item_count : null;
      })
      .catch(function() { return null; });
  }

  // Baseline so we can tell whether a later read reflects our addition.
  let knownCartCount = null;
  fetchCartCount().then(function(count) { knownCartCount = count; });

  // Poll the cart until the count rises above the baseline, then enrich the
  // toast. Never contradicts the optimistic message — if the count can't be
  // confirmed the toast simply stays as-is.
  function confirmCartCount(attempt) {
    attempt = attempt || 1;
    const baseline = knownCartCount;

    fetchCartCount().then(function(count) {
      if (count !== null && (baseline === null || count > baseline)) {
        knownCartCount = count;
        const noun = count === 1 ? 'item' : 'items';
        if (cartToast && cartToast.classList.contains('is-visible') && cartToastDetail) {
          cartToastDetail.textContent += ` · ${count} ${noun} in cart`;
        }
        return;
      }
      if (attempt < 8) setTimeout(function() { confirmCartCount(attempt + 1); }, 500);
    });
  }

  function triggerReserveFeedback(sourceEl) {
    const label = `${currentQuantity} × ${TYPE_LABELS[currentType] || 'Ticket'}`;

    // Pressed state via a class only — never rewrite the button's text, because
    // updateDisplay() holds references to the .ticket-count and .final-price
    // spans inside it.
    if (sourceEl) {
      sourceEl.classList.add('is-adding');
      setTimeout(function() { sourceEl.classList.remove('is-adding'); }, 850);
    }

    const target = getCartTarget();
    animateTicketToCart(sourceEl || reserveForm, label, {
      targetRect: target.rect,
      targetEl: target.el,
      pop: true
    });

    showToast(label);
    confirmCartCount();
  }

  // Capture phase on document: runs before the theme's own handlers, so the
  // feedback fires even if the theme cancels the event afterwards. The event is
  // never modified here — the cart add proceeds exactly as it does today.
  document.addEventListener('click', function(e) {
    const btn = e.target && e.target.closest ? e.target.closest('.reserve-btn') : null;
    if (!btn || !reserveForm.contains(btn)) return;
    if (currentQuantity === 0) return;
    // No cart animation or toast for a sold-out type — nothing is being added.
    if (isSoldOut(currentType)) return;
    triggerReserveFeedback(btn);
  }, true);

  // Keyboard submissions (Enter in the quantity field) bypass the click above,
  // so mirror the feedback here. Guarded against double-firing by the click
  // path, which is the common case.
  reserveForm.addEventListener('submit', function(e) {
    // Last line of defence: a keyboard Enter, or a theme script that clears the
    // button's disabled attribute, must still not reach /cart/add.
    if (isSoldOut(currentType)) {
      e.preventDefault();
      return;
    }
    if (currentQuantity === 0) {
      e.preventDefault();
      alert('Please select at least one ticket.');
      return;
    }
    if (!cartToast || !cartToast.classList.contains('is-visible')) {
      triggerReserveFeedback(reserveForm.querySelector('.reserve-btn'));
    }
  });

  // Initialize display on load. applyTierData() runs first because it paints
  // the per-tier prices and sold-out treatment, and may move currentType off a
  // sold-out tier — both of which the two calls below depend on.
  applyTierData();
  syncQuantityBounds();
  updateDisplay();
});
